import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { leadQueryKeys } from "./leadQueryKeys";

export function useMutationCreateLeadStatus(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOpts?: UseMutationOptions<unknown, unknown, { newName: string }>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ newName }: { newName: string }) =>
      api.leadApi.createStatusColumn(newName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
    },
    ...mutationOpts,
  });
}
